import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Typography } from '@mui/material';
//
import { BaseOptionChart } from '../../dash_charts/BaseOptionChart'
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------
var pt = require("apexcharts/dist/locales/pt.json");

const CHART_DATA = [
    {
    name: 'Dor (EVA)',
    type: 'area',
    data: [8,8,6,7,5,4,3,5,3,5]
    },
  {
    name: 'Esforço (Borg)',
    type: 'area',
    data: [9,8,7,8,10,5,7,6,2,3]
  },
];

export default function EsforcoDorExercicios() {
    const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      locales: [pt],
      defaultLocale: 'pt',
    },

    colors: [
        theme.palette.error.main,
        theme.palette.warning.main
      ],
    stroke: { 
      width: [3,2.5],
      curve: 'smooth'
    },
    plotOptions: { 
      bar: { columnWidth: '11%', borderRadius: 4 } 
    },
    fill: { 
      type: 'gradient',
    },
    labels: [
      '01/01/2021',
      '02/01/2021',
      '03/01/2021',
      '04/01/2021',
      '05/01/2021',
      '06/01/2021',
      '07/01/2021',
      '08/01/2021',
      '09/01/2021',
      '10/01/2021',
      '11/01/2021'
    ],
    xaxis: { 
      type: 'datetime' 
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} `; // write something
          }
          return y;
        }
      }
    }
  });

  return (
    
    <Typography variant="h6">Dor e Esforço
    <ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={250} />
    </Typography>
   

  );
}
